export const isDateInputSupported = function(): boolean {
	try {
		const input = document.createElement( 'input' );
		input.setAttribute( 'type', 'date' );

		const date = new Date( '2006-01-02T00:00:00.000Z' );
		input.value = '2006-01-02';

		if ( input.valueAsDate?.toISOString() === date.toISOString() ) {
			return true;
		}

	} catch {
		return false;
	}

	return false;
};

export function formatDate( date: Date ): string {
	const month = padDatePart( date.getUTCMonth() + 1 );
	const day = padDatePart( date.getUTCDate() );
	const year = date.getUTCFullYear().toString();

	return `${year}-${month}-${day}`;
}

export function formatShortDate( date: Date ): string {
	const month = padDatePart( date.getUTCMonth() + 1 );
	const day = date.getUTCDate().toString();

	return `${day}/${month}`;
}

const monthNames = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];

export function formatLongDate( date: Date ): string {
	const month = monthNames[date.getUTCMonth()];
	const day = date.getUTCDate().toString();
	const year = date.getUTCFullYear();

	return `${month} ${day}, ${year}`;
}

export function formatCalendarDate( date: Date ): string {
	const month = monthNames[date.getMonth()];
	const year = date.getFullYear();

	return `${month} ${year}`;
}

export function parseDate( text: string ): Date | null {
	if ( /^\d{4,}-[0-1][0-9]-[0-3][0-9]$/.test( text ) ) {
		const parts = text.split( '-' );
		const dYear = Number( parts[0] );
		const dMonth = Number( parts[1] );
		const dDay = Number( parts[2] );
		if ( 0 === dYear || 0 === dMonth || 0 === dDay ) {
			return null;
		}

		if ( 12 < dMonth ) {
			return null;
		}

		const out = new Date( Date.UTC( dYear, dMonth - 1, dDay ) );
		out.setUTCFullYear( dYear );

		return out;
	}

	return null;

}

export function padDatePart( part: string | number ): string {
	return `00${part}`.slice( -2 );
}
